import { ESortOrder } from "@domains/utils/sort";
import { BtnDNAproperties, EBtnDNAproperties, } from "@frameworks/web/components/Reports/RebrandedReports/constant";
import TwinBtns from "@frameworks/web/components/Reports/RebrandedReports/GenericComponents/TwinBtns";
import React, { useEffect, useState } from "react";
/**
 * @param props
 * @returns sort options for mobile
 */
const ReportSorts = (props) => {
    var _a, _b;
    const [tempSelectedSorts, setTempSelectedSorts] = useState({
        list: [],
    });
    const onChange = (sort) => {
        let prevorder = sort === null || sort === void 0 ? void 0 : sort.order;
        if (prevorder === ESortOrder.UNCHANGED)
            prevorder = ESortOrder.ASC;
        else if (prevorder === ESortOrder.ASC)
            prevorder = ESortOrder.DESC;
        else
            prevorder = ESortOrder.UNCHANGED;
        let updateSortOrder = tempSelectedSorts === null || tempSelectedSorts === void 0 ? void 0 : tempSelectedSorts.list.map((currentSort) => {
            if ((sort === null || sort === void 0 ? void 0 : sort.key) === (currentSort === null || currentSort === void 0 ? void 0 : currentSort.key))
                return Object.assign(Object.assign({}, currentSort), { order: prevorder });
            return Object.assign(Object.assign({}, currentSort), { order: ESortOrder.UNCHANGED });
        });
        setTempSelectedSorts({ list: updateSortOrder });
    };
    useEffect(() => {
        setTempSelectedSorts(props === null || props === void 0 ? void 0 : props.sortList);
    }, [props === null || props === void 0 ? void 0 : props.sortList]);
    const applySort = () => {
        let selectedOrder = tempSelectedSorts === null || tempSelectedSorts === void 0 ? void 0 : tempSelectedSorts.list.find((currentSort) => (currentSort === null || currentSort === void 0 ? void 0 : currentSort.order) !== ESortOrder.UNCHANGED);
        props === null || props === void 0 ? void 0 : props.applySort(selectedOrder, tempSelectedSorts);
    };
    return (React.createElement("div", { className: "sort-list-container" },
        React.createElement("div", { className: "sort-options" }, (_b = (_a = tempSelectedSorts === null || tempSelectedSorts === void 0 ? void 0 : tempSelectedSorts.list) === null || _a === void 0 ? void 0 : _a.map) === null || _b === void 0 ? void 0 : _b.call(_a, (sort) => {
            var _a, _b;
            return (React.createElement("div", { className: "sort-option", onClick: () => onChange(sort) },
                React.createElement("span", { className: "sort-title" }, sort === null || sort === void 0 ? void 0 : sort.title),
                React.createElement("span", { className: `sort-ordertext ${(sort === null || sort === void 0 ? void 0 : sort.order) !== ESortOrder.UNCHANGED
                        ? "selected-sort-state"
                        : ""}` },
                    (sort === null || sort === void 0 ? void 0 : sort.order) === ESortOrder.ASC ||
                        (sort === null || sort === void 0 ? void 0 : sort.order) === ESortOrder.UNCHANGED
                        ? (_a = sort === null || sort === void 0 ? void 0 : sort.orderText) === null || _a === void 0 ? void 0 : _a.asc
                        : (_b = sort === null || sort === void 0 ? void 0 : sort.orderText) === null || _b === void 0 ? void 0 : _b.desc,
                    " ",
                    (sort === null || sort === void 0 ? void 0 : sort.order) === ESortOrder.ASC ||
                        (sort === null || sort === void 0 ? void 0 : sort.order) === ESortOrder.UNCHANGED ? (React.createElement("i", { className: "edel-icon-point-arrow-down" })) : (React.createElement("i", { className: "edel-icon-point-arrow-up" })))));
        })),
        React.createElement("div", { className: "sort-apply-cancel-btns" },
            React.createElement(TwinBtns, { parentClass: "buy-sell-btns buy-sell-btns-spacing ", leftBtn: Object.assign(Object.assign({}, BtnDNAproperties[EBtnDNAproperties.CANCEL]), { onClick: () => props === null || props === void 0 ? void 0 : props.setOpenDrawer(false) }), rightBtn: Object.assign(Object.assign({}, BtnDNAproperties[EBtnDNAproperties.APPLY]), { onClick: () => applySort() }) }))));
};
export default ReportSorts;
